import {toLowCaseCleanSpaces} from "../../core/utils/Texts";

class UrlQueryParams {
    constructor(query, name) {
        this.query = query;
        this.name = name;
    }
    setSearchParams(filters) {
        if (this.query.has(this.name)) {
            let uid = this.query.get(this.name);
            let search = document.getElementById("topbar-searcher");
            search.value = this.query.get("uid");
            filters.current.chosen.searcher = toLowCaseCleanSpaces(uid);
            filters.current.filter();
        }
    }
}
export default UrlQueryParams;